import { render, staticRenderFns } from "./Webinar.vue?vue&type=template&id=2c9011c0&scoped=true"
import script from "./Webinar.vue?vue&type=script&lang=js"
export * from "./Webinar.vue?vue&type=script&lang=js"
import style0 from "./Webinar.vue?vue&type=style&index=0&id=2c9011c0&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9011c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbsdevops/devops/jenkins-slave/workspace/bizbize-frontend-dev/xpermeet-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c9011c0')) {
      api.createRecord('2c9011c0', component.options)
    } else {
      api.reload('2c9011c0', component.options)
    }
    module.hot.accept("./Webinar.vue?vue&type=template&id=2c9011c0&scoped=true", function () {
      api.rerender('2c9011c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Webinar.vue"
export default component.exports